<template>
    <div class="ws-page submenu-page">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">
                Dashboard
            </router-link>
            <span class="text-white">
                <i class="fa fa-ellipsis-v px-2" aria-hidden="true"></i>
                {{ title }}
            </span>
        </base-header>

        <div class="container-fluid mt--7 ws-page__body">
            <section class="ws-panel" aria-labelledby="submenu-page-title">
                <header class="ws-panel__intro">
                    <div class="ws-panel__text">
                        <span class="ws-eyebrow">{{ eyebrow }}</span>
                        <h1 id="submenu-page-title">{{ title }}</h1>
                        <p>{{ description }}</p>
                    </div>
                    <div class="ws-panel__side">
                        <div class="ws-stat" aria-live="polite">
                            <strong>{{ displayedCount }}</strong>
                            <span>{{ countLabel }}</span>
                        </div>
                    </div>
                </header>

                <slot />
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: "submenu-page",
    props: {
        title: { type: String, required: true },
        eyebrow: { type: String, default: "SCHOOL MANAGEMENT" },
        description: { type: String, default: "Choose a tool to continue." },
        countLabel: { type: String, default: "menu items" }
    },
    data() {
        return { submenuCount: 0 };
    },
    computed: {
        displayedCount() {
            return this.submenuCount;
        }
    },
    provide() {
        return {
            setSubmenuCount: (count) => {
                this.submenuCount = Math.max(0, Number(count) || 0);
            }
        };
    }
};
</script>

<style scoped>
.submenu-page .ws-panel__intro {
    align-items: flex-end;
}

@media (max-width: 575.98px) {
    .submenu-page .ws-panel__intro {
        align-items: flex-start;
    }
}
</style>
